// =====================================================================
// Realtime + prefetch — модульная инициализация (одна на сессию, без
// useEffect, как visibilitychange в query-client).
// =====================================================================
// 1) Подписка на публичный broadcast-канал "orders": при любом изменении
//    заказа инвалидируем order-запросы → админ/курьер/покупатель видят
//    обновление мгновенно (поллинг остаётся как фолбэк).
// 2) Prefetch статики (настройки, категории) — каталог/профиль рендерятся
//    без ожидания первого запроса.
// =====================================================================

import { getSupabase } from "@/shared/api/supabase";
import { queryClient } from "@/app/providers/query-client";
import { settingsMapOptions } from "@/entities/settings";
import { categoryTreeOptions } from "@/entities/category";

if (typeof window !== "undefined") {
  getSupabase()
    .channel("orders")
    .on("broadcast", { event: "changed" }, () => {
      void queryClient.invalidateQueries({ queryKey: ["order"] });
    })
    .subscribe();

  void queryClient.prefetchQuery(settingsMapOptions());
  void queryClient.prefetchQuery(categoryTreeOptions());
}
